import React from 'react';
import './FormStyles.css';

export default function DateInput({
  label,
  name,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  min = null,
  max = null,
  className = '',
}) {
  const formatDateForInput = (date) => {
    if (!date) return '';
    if (typeof date === 'string') return date.split('T')[0];
    if (date instanceof Date) {
      return date.toISOString().split('T')[0];
    }
    return '';
  };

  const handleChange = (e) => {
    onChange(e);
  };

  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label htmlFor={name} className="form-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <input
        id={name}
        type="date"
        name={name}
        value={formatDateForInput(value)}
        onChange={handleChange}
        disabled={disabled}
        min={min}
        max={max}
        className={`form-input ${error ? 'error' : ''}`}
      />
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}
